import React from 'react';
import { urls } from '..';
import XRouterLink from '../common/seo/xrouter/XRouterLink';
import { classIf } from '../data/utils/classIf';
import { useFavorites } from '../common/FavoritesProvider';
import { getLabel } from '../data/labels';

export default function FavoritesButton() {
    const favorites = useFavorites();
    const favoritesSet = new Set(Object.keys(favorites));

    return (
        <XRouterLink to={`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/preferiti`} className={"favorite-icon-container relative h-sports-navbar-height min-w-sports-navbar-height mx-1 shrink-0 flex flex-col items-center justify-center" + classIf(false, 'xs_selected')}>
            <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center">
                <div className={"col-start-1 col-end-13 row-start-1 row-end-10 inline-block h-[24px] w-[24px]"}>
                    <i className="xs-font-icon bi-star-fill text-cs1" />
                </div>
                <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{`${getLabel('general.favorites')} (${favoritesSet.size})`}</div>
            </div>
            {false &&
                <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-cs4 rounded-xl"></div>
            }
        </XRouterLink>
    );
}
